module.exports = __webpack_public_path__ + "public/img/elecChart.2c839a5b.png";